import { FabricJSCanvas, useFabricJSEditor } from 'fabricjs-react';
import { fabric } from 'fabric';
import React, { useEffect, useRef, useState } from 'react';
import { IEvent } from 'fabric/fabric-impl';
import { FaImage } from 'react-icons/fa';
import { getImage, uploadFile } from '../../../server/server';
import { DEFAULT_HEIGHT, DEFAULT_LEFT, DEFAULT_TOP, DEFAULT_WIDTH, FAKE_RESTRICTION_AREA, VIRTUAL_CANVAS_SIZE } from '../../../Constants';
import { Button, TextField } from '@mui/material';
import Loading from '../../../common/Loading';

function PresentationPicture({ product, setProduct }: { product: any; setProduct: any }) {
	const { editor, onReady } = useFabricJSEditor();
	const fileInputRef = useRef<HTMLInputElement | null>(null);
	const [canvasHeight, setCanvasHeight] = useState(300);

	const [loading, setLoading] = useState(false);
	const [fieldError, setFieldError] = useState<any>({ height: '', width: '' });
	const [proportions, setProportions] = useState<any>({ width: 0.0, height: 0.0 });
	const [originalAspectRatio, setOriginalAspectRatio] = useState<number>(1);
	const [canvasReady, setCanvasReady] = useState(false);
	const scaleFactor = useRef(1);

	const updateDimensions = (obj: any) => {
		if (!!obj) {
			const left = obj.left ?? 0;
			const top = obj.top ?? 0;
			const currentWidth = (obj.getScaledWidth() ?? 0) - 1;
			const currentHeight = (obj.getScaledHeight() ?? 0) - 1; //mora ovo zbog border 1 posto se to iz nekog razloga dodaje
			const scale = scaleFactor.current;
			console.log(obj);
			console.log('Odnos: ', currentWidth / currentHeight);

			setProduct({ ...product, restricted: [left / scale, top / scale, currentWidth / scale, currentHeight / scale] });
			loadRestrictedRect([left, top, currentWidth, currentHeight]);
		}
	};

	const handleWChange = (e: any) => {
		console.log(`e`, e);

		setProportions({ ...proportions, width: e });
		setProduct({ ...product, pdfW: parseFloat(e) });
	};
	const handleHChange = (e: any) => {
		setProportions({ ...proportions, height: e });
		setProduct({ ...product, pdfH: parseFloat(e) });
	};

	useEffect(() => {
		setProportions({ width: product?.pdfW, height: product?.pdfH });
	}, []);

	useEffect(() => {
		if (!!product.restrictedImage && canvasReady) {
			setImage();
		}
		return () => {
			editor?.canvas.off();
		};
	}, [product.restrictedImage, canvasReady]);

	const isLessThanZero = (num: any, msg: string) => {
		if (num <= 0) return msg;
		return '';
	};

	const onAddRectangle = () => {
		setFieldError({ width: isLessThanZero(proportions?.width, 'Width is required'), height: isLessThanZero(proportions?.height, 'Height is required') });
		if (editor?.canvas.isEmpty()) {
			alert('You must select an image before creating a rectangle.');
			return;
		} else if (editor?.canvas.getObjects('rect')?.length !== 0) {
			const rectangles: fabric.Object[] | undefined = editor?.canvas.getObjects('rect');
			rectangles?.forEach((item: fabric.Object) => {
				editor?.canvas.remove(item);
			});
		}
		// editor?.canvas.add(new fabric.Rect({ width: editor.canvas.getWidth(), height: editor.canvas.getHeight(), fill: 'rgba(128, 128, 128, 0.7)', top: 0, left: 0, selectable: false }));
		const restrictedArea = {
			width: parseFloat(proportions?.width) ?? 10,
			height: parseFloat(proportions?.height) ?? 10,
			left: parseFloat(proportions?.width) ?? 10,
			top: parseFloat(proportions?.height) ?? 10,
		};

		const width = proportions?.width ?? 10;
		const height = proportions?.height ?? 10;
		const aspectRatio = width / height;
		setOriginalAspectRatio(aspectRatio);

		// rect.on('scaling', function (e) {
		// 	const target = e.target;
		// 	if (!target) return;

		// 	const width = target.getScaledWidth();
		// 	const height = target.getScaledHeight();
		// 	const currentRatio = width / height;

		// 	// If aspect ratio changed significantly, correct it
		// 	if (Math.abs(currentRatio - aspectRatio) > 0.01) {
		// 		if (width > height * aspectRatio) {
		// 			target.scaleToHeight(width / aspectRatio);
		// 		} else {
		// 			target.scaleToWidth(height * aspectRatio);
		// 		}
		// 	}
		// });
		const scale = scaleFactor.current;

		setProduct({ ...product, restricted: [restrictedArea.left / scale, restrictedArea.top / scale, restrictedArea.width / scale, restrictedArea.height / scale] });
		loadRestrictedRect([restrictedArea.left, restrictedArea.top, restrictedArea.width * 20, restrictedArea.height * 20]);
	};
	const onImageUpload = async (event: any) => {
		setFieldError({ width: isLessThanZero(proportions?.width, 'Width is required'), height: isLessThanZero(proportions?.height, 'Height is required') });

		if (!event.target.files || event.target.files.length === 0) {
			return;
		}
		setLoading(true);
		let file = event.target.files[0];
		if (!!file) {
			const resp = await uploadFile({ file: file, selectable: 'true' });
			if (resp.status == 201) {
				const uploadedImage = resp.data;

				setProduct({ ...product, restrictedImage: uploadedImage.id });

				// setImageToRestrictedArea(file);
				setLoading(false);
			} else {
				setLoading(false);
				return;
			}
		}
	};
	const setImage = () => {
		const image = getImage(product.restrictedImage);
		const imgElement = new Image();
		console.log(`image`, image);
		imgElement.src = image as string;
		imgElement.onload = () => {
			const fabricImage = new fabric.Image(imgElement);
			const scaleX = VIRTUAL_CANVAS_SIZE / (fabricImage.width ?? 1);
			const scaleY = VIRTUAL_CANVAS_SIZE / (fabricImage.height ?? 1);
			const scale = Math.min(scaleX, scaleY);
			scaleFactor.current = scale;
			fabricImage.scale(scale);

			// fabricImage.scale(scale);
			editor?.canvas.setWidth(fabricImage.getScaledWidth());
			editor?.canvas.setHeight(fabricImage.getScaledHeight());

			fabricImage.selectable = false;
			editor?.canvas.clear();
			// editor?.canvas.add(fabricImage);
			editor?.canvas?.setBackgroundImage(fabricImage, editor?.canvas?.requestRenderAll.bind(editor?.canvas), {});
			// editor?.canvas.add(new fabric.Rect({ width: editor.canvas.getWidth(), height: editor.canvas.getHeight(), fill: 'rgba(128, 128, 128, 0.6)', top: 0, left: 0, selectable: false }));
			const restricted = product.restricted?.map((c: any) => c * scale);
			loadRestrictedRect(restricted);
		};
	};
	const loadRestrictedRect = (_restricted: number[] = []) => {
		let restricted = _restricted;
		if (restricted?.length === 0) {
			console.log('No restricted area');
			restricted = [(proportions?.width ?? 10) * 0.15, (proportions?.height ?? 10) * 0.15, (proportions?.width ?? 10) * 8, (proportions?.height ?? 10) * 8];
		}
		if (editor?.canvas.getObjects('rect')?.length !== 0) {
			const rectangles: fabric.Object[] | undefined = editor?.canvas.getObjects('rect');
			rectangles?.forEach((item: fabric.Object) => {
				editor?.canvas.remove(item);
			});
		}
		const rect = new fabric.Rect({
			width: restricted?.[2],
			height: restricted?.[3],
			fill: '#ffffff70',
			top: restricted?.[1],
			left: restricted?.[0],
			borderColor: '#ff0000',
			borderScaleFactor: 1,
			strokeUniform: true,
			strokeWidth: 1,
			stroke: '#ff0000',
			lockUniScaling: true,
		});
		rect.setControlsVisibility({
			mt: false,
			mb: false,
			ml: false,
			mr: false,
			mtr: false,
		});

		editor?.canvas.add(rect);
		rect.on('modified', function (e) {
			const target = e.target;
			updateDimensions(target);
		});
		editor?.canvas.renderAll();
	};

	const onCanvasReady = (c: any) => {
		onReady(c);
		setCanvasReady(true);
	};

	return (
		<div className="flex w-full flex-row mt-10 border border-mediumGrey rounded-md p-[30px] gap-5  h-full" key={product}>
			<div className="flex flex-col items-center h-full">
				<p className=" text-darkGrey text-lg  px-2">Printable area</p>
				<div className="flex flex-col gap-3">
					<div>
						<div className=" w-[250px]">
							<TextField
								required
								className=" background-transparent "
								value={proportions?.width}
								onFocus={() => setFieldError({ ...fieldError, width: '' })}
								onChange={(e) => handleWChange(e.target.value)}
								helperText={fieldError?.width ?? ''}
								error={!!fieldError?.width}
								fullWidth
								label="Width in cm"
								variant="filled"
							/>
						</div>
						<div className=" w-[250px]">
							<TextField
								required
								className=" background-transparent "
								value={proportions?.height}
								onFocus={() => setFieldError({ ...fieldError, height: '' })}
								onChange={(e) => handleHChange(e.target.value)}
								helperText={fieldError?.height ?? ''}
								error={!!fieldError?.height}
								fullWidth
								label="Height in cm"
								variant="filled"
							/>
						</div>
					</div>
					<div className="flex flex-col gap-6 mt-4">
						<div className="">
							<input type="file" accept="image/*" ref={fileInputRef} onChange={onImageUpload} className="hidden" />
							<Button variant="outlined" style={{ backgroundColor: '#eaeaea', color: '#555', fontWeight: 600, border: '1px solid #777777', minWidth: 250 }} disabled={loading} onClick={() => fileInputRef.current?.click()}>
								{!loading ? (
									<div className="flex flex-row items-center justify-center">
										<FaImage />
										<span className="ml-3">Upload Image</span>
									</div>
								) : (
									<Loading height={18} />
								)}
							</Button>
						</div>
						<div>
							<Button variant="outlined" style={{ backgroundColor: '#eaeaea', color: '#555', fontWeight: 600, border: '1px solid #777777', minWidth: 250 }} onClick={() => onAddRectangle()}>
								Add rectangle
							</Button>
						</div>
					</div>
				</div>
			</div>

			<div className="h-full">
				<FabricJSCanvas onReady={onCanvasReady} className="w-[500px] h-[500px] fabric-container flex items-center justify-center" />
				{/* {scale} */}
				{/* <br /> */}
				{/* {getImage(product.restrictedImage)} */}
			</div>
		</div>
	);
}

export default PresentationPicture;
